import { Box, Button, Paper, Tab, Tabs } from '@material-ui/core';
import MapIcon from '@material-ui/icons/Map';
import React from 'react';
import useStyles from '../styles';
import AccountInfoPanel from './AccountInfoPanel';
import VehicleInfoPanel from './VehicleInfoPanel';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const DeviceInfoCard = ({
  vehicle,
  tabValue,
  onChangeTab,
  isAdmin,
  canWarehouseTransfer,
  onBatchTransfer,
  onViewOnMap,
  canWarrantyReplace,
  onWarrantyReplaced,
  onDriverLoginSuccess
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.card}>
      <Tabs
        value={tabValue}
        onChange={(e, v) => onChangeTab(v)}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        className={classes.infoTabs}
      >
        <Tab label="Thông tin thiết bị" />
        <Tab label="Thông tin tài khoản" />
      </Tabs>

      <Box className={classes.cardBody}>
        <TabPanel value={tabValue} index={0}>
          <VehicleInfoPanel
            vehicle={vehicle}
            canWarrantyReplace={canWarrantyReplace}
            onWarrantyReplaced={onWarrantyReplaced}
            onDriverLoginSuccess={onDriverLoginSuccess}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <AccountInfoPanel vehicle={vehicle} isAdmin={isAdmin} canWarehouseTransfer={canWarehouseTransfer} onBatchTransfer={onBatchTransfer} />
        </TabPanel>
      </Box>

      <Button
        fullWidth
        className={`btn-main btn-plain ${classes.mapButton}`}
        color="primary"
        variant="contained"
        startIcon={<MapIcon />}
        onClick={onViewOnMap}
        disabled={!vehicle.device_id}
      >
        Xem trên bản đồ giám sát
      </Button>
    </Paper>
  );
};

export default DeviceInfoCard;
